import React from 'react';
import { useTranslation } from 'react-i18next';
import './QoreConnectPages.css';

/**
 * Unified sub-page hero for Forum, Mentorship, Jobs
 * @param {'cyan'|'violet'|'emerald'} accent
 */
const QoreConnectPageHero = ({
  accent = 'cyan',
  badgeKey,
  titleKey,
  accentKey,
  subtitleKey,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <header className={`qc-sub-hero qc-sub-hero--${accent}`}>
      <div className="qc-sub-hero__inner">
        {badgeKey && <div className="qc-sub-hero__badge">{t(badgeKey)}</div>}
        <h1 className="qc-sub-hero__title">
          {t(titleKey)}{' '}
          {accentKey && <span className="qc-sub-hero__accent">{t(accentKey)}</span>}
        </h1>
        {subtitleKey && <p className="qc-sub-hero__subtitle">{t(subtitleKey)}</p>}
        {children && <div className="qc-sub-hero__actions">{children}</div>}
      </div>
    </header>
  );
};

export default QoreConnectPageHero;